import { createContext } from 'react';
var defaultLocale = (typeof navigator !== 'undefined' && navigator.language) || 'ru-RU';
export var LocaleContext = createContext(defaultLocale);
